import { useState } from 'react';
import { useApiHook } from '../../../hook/useApiHook';
import { MODAL_TYPE, modalStore } from '../../../store/modalStore';
import { UsedTicketModal } from './UsedTicketModal';
import { NumberPad } from './NumberPad';
import { useIsMobile } from '../../../hook/useIsMobile';
import { TicketWithUsedButtonPc } from './TicketWithUsedButton/TicketWithUsedButton.pc';
import { TicketWithUsedButtonMobile } from './TicketWithUsedButton/TicketWithUsedButton.mobile';

export type TicketWithUsedButtonViewProps = {
  ticketNumber: number;
  tempUsed: string;
  onUseButtonClick: () => void;
};

export const TicketWithUsedButton = ({
  ticketNumber,
  isUsed,
}: {
  ticketNumber: number;
  isUsed: string;
}) => {
  const isMobile = useIsMobile();
  const [visiblePad, setVisiblePad] = useState(false);
  const [usedTicket, setUsedTicket] = useState(false);
  const [password, setPassword] = useState<string>('');
  const { ticketUse, getEventInfo } = useApiHook();
  const { showModal } = modalStore();
  const [tempUsed, setTempUsed] = useState(isUsed);

  const onUseButtonClick = () => {
    setPassword('');
    setVisiblePad(true);
  };

  const viewProps = { ticketNumber, tempUsed, onUseButtonClick };

  return (
    <>
      {isMobile ? (
        <TicketWithUsedButtonMobile {...viewProps} />
      ) : (
        <TicketWithUsedButtonPc {...viewProps} />
      )}

      <NumberPad
        password={password}
        setPassword={setPassword}
        visiblePad={visiblePad}
        close={() => {
          setPassword('');
          setVisiblePad(false);
        }}
        showUsedTicket={() => setUsedTicket(true)}
      />

      <UsedTicketModal
        isVisibleCommon={usedTicket}
        commonCallback1={async () => {
          try {
            await ticketUse(ticketNumber);
            await getEventInfo();
            setUsedTicket(false);
            setTempUsed('Y');
          } catch (e) {
            console.log(e);
          }
        }}
        commonCallback2={() => {
          setUsedTicket(false);
        }}
      />
    </>
  );
};
